{% block ecocode_trustpilot_switch_field_config %}
    <div class="ecocode-trustpilot-switch-field__block">
        {% parent %}
    </div>
{% endblock %}
